// Full-page route wrapper — reuses the SubmissionDetailDrawer.
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "@/components/admin/AdminLayout";
import { Toaster } from "sonner";
import SubmissionDetailDrawer from "./SubmissionDetailDrawer";

export default function AdminSubmissionDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  return (
    <AdminLayout>
      <Toaster richColors position="top-center" />
      <div className="p-8 text-slate-500 text-sm">Loading submission…</div>
      <SubmissionDetailDrawer id={id} onClose={() => nav("/admin/submissions")} />
    </AdminLayout>
  );
}
